import React, { useState, useContext } from 'react';
import Modal from '../../../common/Modal';
import { QueryContext } from '../../../../hooks/Contexts';

const LinkedFilterModal = ({ viewLinkedFilter, setViewLinkedFilter }) => {
  const { queryParams, setQueryParams } = useContext(QueryContext);
  const [parentID, setParentID] = useState(queryParams.filters.parent_id || '');
  const [error, setError] = useState('');
  const filters = queryParams.filters;
  const viewLinked =
    Object.keys(filters).includes('has_group') && filters.has_group;
  const viewUnlinked =
    Object.keys(filters).includes('has_group') && !filters.has_group;
  const viewByParentID = Object.keys(filters).includes('parent_id');

  const handleCloseModal = () => {
    setViewLinkedFilter(false);
  };

  const handleParentSearch = () => {
    const validInput = /^[1-9][0-9]*$/;
    if (queryParams.filters['parent_id'] && !parentID.length) {
      setQueryParams((params) => {
        delete params.filters['parent_id'];
        return { ...params };
      });
    } else if (validInput.test(parentID)) {
      setQueryParams((params) => {
        delete params.filters['has_group'];
        return {
          ...params,
          filters: { ...params.filters, parent_id: parentID },
        };
      });
    } else {
      setError('Invalid ID');
    }
  };

  const handleLinkFilter = (showLinked) => {
    let query = showLinked ? 1 : 0;
    setQueryParams((params) => {
      delete params.filters['parent_id'];
      return { ...params, filters: { ...params.filters, has_group: query } };
    });
    handleCloseModal();
  };

  const handleRemoveFilters = () => {
    setQueryParams((state) => {
      delete state.filters['has_group'];
      delete state.filters['parent_id'];
      return { ...state };
    });
    setParentID('');
    setError('');
    handleCloseModal();
  };

  return (
    <Modal
      title='filter-linked-modal'
      show={viewLinkedFilter}
      onClose={() => handleCloseModal()}
    >
      <header>
        <h3>Filter Linked Submissions</h3>
      </header>

      <div className='creation-form'>
        <div className='row'>
          <label htmlFor='parent-id'>Search by Parent Submission ID:</label>
          {error && (
            <div className='errors'>
              <span>{error}</span>
            </div>
          )}
        </div>
        <div className='row'>
          <div className='half'>
            <input
              type='text'
              id='parent-id'
              value={parentID}
              className={viewByParentID ? 'active' : ''}
              placeholder='Submission ID'
              onChange={(e) => {
                setParentID(e.target.value);
                if (error) setError('');
              }}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  handleParentSearch();
                }
              }}
              maxLength={8}
            />
          </div>
          <div className='third'>
            <button onClick={() => handleParentSearch()}>Search</button>
          </div>
        </div>

        <div className='controls'>
          <hr />
          <button
            id='linked'
            className={viewLinked ? 'active' : ''}
            onClick={() => handleLinkFilter(true)}
          >
            View All Linked
          </button>
          <button
            id='unlinked'
            className={viewUnlinked ? 'active' : ''}
            onClick={() => handleLinkFilter(false)}
          >
            View All Unlinked
          </button>
          <button className='clear' onClick={() => handleRemoveFilters()}>
            Clear Filter
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LinkedFilterModal;
